import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as Reset } from '../assets/icons/reset.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
import { ReactComponent as Search } from '../assets/icons/search.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'

import { useEffect, useState } from 'react'
import { getStudents } from '../apis/student.ts'
import { postCoursesStudent } from '../apis/course.ts'
import { getSchoolsClass, getSchoolsGrade, getSchoolsMajorGroup } from '../apis/school.ts'

export default function StudentAddModal({ close, courseId, getApi, semesterId, existingStudent }) {
  const [studentList, setStudentList] = useState()
  const [gradeList, setGradeList] = useState()
  const [classList, setClassList] = useState()
  const [majorGroupList, setMajorGroupList] = useState()
  const [selectedStudent, setSelectedStudent] = useState([])
  const [search, setSearch] = useState()

  useEffect(() => {
    getStudentsApi()
    // eslint-disable-next-line
  }, [search])

  useEffect(() => {
    getSchoolsClassApi()
    getSchoolsMajorGroupApi()
    getSchoolsGradeApi()
    // eslint-disable-next-line
  }, [])

  const getStudentsApi = async () => {
    const getStudentsResponse = await getStudents({
      name: search?.name,
      grade: search?.grade,
      classNumber: search?.class,
      majorGroup: search?.major,
    })

    if (getStudentsResponse.error) {
      console.log(getStudentsResponse)
      return
    } else {
      // console.log(getStudentsResponse.data)
      setStudentList(getStudentsResponse.data)
    }
  }

  const getSchoolsClassApi = async () => {
    const getSchoolsClassResponse = await getSchoolsClass({
      semesterId: semesterId,
    })

    if (getSchoolsClassResponse.error) {
      console.log(getSchoolsClassResponse)
      return
    } else {
      // console.log(getSchoolsClassResponse.data)
      setClassList(getSchoolsClassResponse.data)
    }
  }

  const getSchoolsMajorGroupApi = async () => {
    const getSchoolsMajorGroupResponse = await getSchoolsMajorGroup()

    if (getSchoolsMajorGroupResponse.error) {
      console.log(getSchoolsMajorGroupResponse)
      return
    } else {
      // console.log(getSchoolsMajorGroupResponse.data)
      setMajorGroupList(getSchoolsMajorGroupResponse.data)
    }
  }
  const getSchoolsGradeApi = async () => {
    const getSchoolsGradeResponse = await getSchoolsGrade()

    if (getSchoolsGradeResponse.error) {
      console.log(getSchoolsGradeResponse)
      return
    } else {
      // console.log(getSchoolsGradeResponse.data)
      setGradeList(getSchoolsGradeResponse.data)
    }
  }

  const handleSelectClick = (studentItem) => {
    if (!selectedStudent.includes(studentItem.id)) {
      setSelectedStudent((prev) => [...prev, studentItem.id])
    } else {
      const unSelectedStudent = selectedStudent.filter((item) => item !== studentItem.id)
      setSelectedStudent(unSelectedStudent)
      // console.log(unSelectedStudent)
    }
  }

  const postCoursesStudentApi = async () => {
    const postCoursesStudentResponse = await postCoursesStudent(
      {
        courseId: courseId,
      },
      selectedStudent,
    )
    if (postCoursesStudentResponse.error) {
      console.log(postCoursesStudentResponse.message)
      return
    } else {
      console.log(postCoursesStudentResponse.result)
      close()
      await getApi()
    }
  }

  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_default relative flex w-[600px] flex-col gap-20 fill-label-default'>
        <div className='flex items-center justify-between'>
          <p className='text-h1-semibold text-label-default'>학생 추가</p>
          <Close className='h-28 w-28' onClick={close} />
        </div>
        <div className='flex flex-col gap-12'>
          <div className='flex items-center justify-between'>
            <div className='flex gap-16'>
              <div className='relative min-w-[110px]'>
                <select
                  value={search?.grade}
                  onChange={(e) => setSearch((prev) => ({ ...prev, grade: e.target.value }))}
                  className={`select_sm peer w-full default:text-label-disable`}
                >
                  <option selected value=''>
                    전체 학년
                  </option>
                  {gradeList?.map((gradeItem, gradeIndex) => (
                    <option key={gradeIndex} value={gradeItem}>
                      {`${gradeItem}학년`}
                    </option>
                  ))}
                </select>
                <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
              </div>
              <div className='relative min-w-[110px]'>
                <select
                  value={search?.class}
                  onChange={(e) => setSearch((prev) => ({ ...prev, class: e.target.value }))}
                  className={`select_sm peer w-full default:text-label-disable`}
                >
                  <option selected value=''>
                    전체 반
                  </option>
                  {classList?.map((classItem, classIndex) => (
                    <option key={classIndex} value={classItem}>
                      {`${classItem}반`}
                    </option>
                  ))}
                </select>
                <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
              </div>
              <div className='relative min-w-[110px]'>
                <select
                  value={search?.major}
                  onChange={(e) => setSearch((prev) => ({ ...prev, major: e.target.value }))}
                  className={`select_sm peer w-full default:text-label-disable`}
                >
                  <option selected value=''>
                    전체 전공그룹
                  </option>
                  {majorGroupList?.map((majorItem, majorIndex) => (
                    <option key={majorIndex} value={majorItem}>
                      {majorItem}
                    </option>
                  ))}
                </select>
                <DownArrow className='pointer-events-none absolute right-10 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
              </div>
            </div>
            <button
              onClick={() => setSearch({ name: '', major: '', class: '', grade: '' })}
              type='reset'
              disabled={!search || Object.values(search).every((value) => value === '')}
              // className='fill-label-info'
              className={`flex cursor-pointer items-center justify-center gap-4 ${!search ? 'fill-label-disable text-label-disable' : Object.values(search).every((value) => value === '') ? 'fill-label-disable text-label-disable' : 'fill-label-info text-label-info'}`}
            >
              <Reset />
              <p className='text-body2-medium'>필터 초기화</p>
            </button>
          </div>
          <div className='relative w-full'>
            <Search className='absolute left-16 top-8' />
            <input
              type='text'
              value={search?.name}
              onChange={(e) => setSearch((prev) => ({ ...prev, name: e.target.value }))}
              placeholder='학생 검색'
              className='input_sm w-full pl-40'
            />
            {search?.name && (
              <CloseFilled
                onClick={() => setSearch((prev) => ({ ...prev, name: '' }))}
                className='absolute right-8 top-8 cursor-pointer'
              />
            )}
          </div>
          <div>
            <div className='flex w-full gap-24 border-y-[1px] border-solid border-border-default bg-fill-alternative px-16 py-8 text-body3-regular text-label-info'>
              <p className='min-w-[140px] shrink-0'>학급번호</p>
              <p className='min-w-[140px] shrink-0'>이름</p>
              <p className='min-w-[140px] shrink-0'>전공그룹</p>
            </div>
            <div className='tab-scroll-bar h-[360px] w-full overflow-y-auto pr-4'>
              {search && studentList?.length === 0 ? (
                <div className='flex h-full w-full items-center justify-center'>
                  <p className='text-center text-body2-long-medium text-label-info'>
                    검색 결과가 없습니다.
                    <br />
                    필터를 다시 설정하거나 다른 검색어를 입력해보세요.
                  </p>
                </div>
              ) : (
                studentList?.map((studentItem, studentIndex) => (
                  <div
                    key={studentIndex}
                    onClick={() => {
                      if (existingStudent?.find((item) => item.id === studentItem.id)) return
                      else {
                        handleSelectClick(studentItem)
                      }
                    }}
                    className={`${selectedStudent.includes(studentItem.id) ? 'bg-background-secondary' : 'bg-background-default'} ${existingStudent?.find((item) => item.id === studentItem.id) ? 'text-label-disable' : 'text-label-sub active:bg-background-secondary'} flex gap-24 border-b-[1px] border-solid border-border-default p-16 text-body2-medium`}
                  >
                    <p className='min-w-[140px] shrink-0'>
                      {`${studentItem.grade}학년 ${studentItem.classNumber}반 ${studentItem.studentNumber}번`}
                    </p>
                    <p className='min-w-[140px] shrink-0'>{studentItem.name}</p>
                    <p className='min-w-[140px] shrink-0'>{studentItem.majorGroup}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className='flex w-full gap-16'>
          <button onClick={close} className='button_outlined_secondary_lg w-full text-label-sub'>
            취소
          </button>
          <button
            onClick={async () => {
              postCoursesStudentApi()
              close()
            }}
            className={`${selectedStudent.length === 0 ? 'button_solid_primary_disabled_lg' : 'button_solid_primary_lg bg-primary-normal'} w-full`}
          >
            {selectedStudent.length === 0 ? `추가` : `추가(${selectedStudent.length})`}
          </button>
        </div>
      </div>
    </div>
  )
}
